import { render, staticRenderFns } from "./KanbanRecordCard.vue?vue&type=template&id=6bb72e4a&scoped=true"
import script from "./KanbanRecordCard.vue?vue&type=script&lang=js"
export * from "./KanbanRecordCard.vue?vue&type=script&lang=js"
import style0 from "./KanbanRecordCard.vue?vue&type=style&index=0&id=6bb72e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb72e4a",
  null
  
)

export default component.exports